import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import useApp from "../../hooks/useApp";
import { Close } from "../../assets/svgs";
import { getBankLogos } from "../../utils/svgUtils";

import "./styles.scss";

export const staticProviders = [
  {
    providerId: "SNB",
    name: "Saudi National Bank",
    displayName: "SNB",
    arabicDisplayName: "البنك الأهلي السعودي",
    logoUrl: "https://tg-external-entities-prod.tarabut.com/SNB.svg",
    countryCode: "SAU",
    aisStatus: "AVAILABLE",
    pisStatus: "UNAVAILABLE",
    supportedAISAuthType: ["Bank"],
    supportedPISAuthType: ["Bank"],
  },
  {
    providerId: "BAAL-SAU",
    name: "Bank Albilad",
    displayName: "Bank Albilad",
    arabicDisplayName: "بنك البلاد",
    logoUrl: "https://tg-external-entities-prod.tarabut.com/BAAL-SAU.svg",
    countryCode: "SAU",
    aisStatus: "AVAILABLE",
    pisStatus: "UNAVAILABLE",
    supportedAISAuthType: ["Bank"],
    supportedPISAuthType: ["Bank"],
  },
  {
    providerId: "RIBL",
    name: "Riyad Bank",
    displayName: "Riyad Bank",
    arabicDisplayName: "بنك الرياض",
    logoUrl: "https://tg-external-entities-prod.tarabut.com/RIBL.svg",
    countryCode: "SAU",
    aisStatus: "AVAILABLE",
    pisStatus: "UNAVAILABLE",
    supportedAISAuthType: ["Bank"],
    supportedPISAuthType: ["Bank"],
  },
  {
    providerId: "SABR-SAU",
    name: "Saudi Awwal Bank",
    displayName: "SAB",
    arabicDisplayName: "البنك السعودي الأول",
    logoUrl: "https://tg-external-entities-prod.tarabut.com/SABR-SAU.svg",
    countryCode: "SAU",
    aisStatus: "AVAILABLE",
    pisStatus: "UNAVAILABLE",
    supportedAISAuthType: ["Bank"],
    supportedPISAuthType: ["Bank"],
  },
  {
    providerId: "BASA-SAU",
    name: "Banque Saudi fransi",
    displayName: "BSF",
    arabicDisplayName: "البنك السعودي الفرنسي",
    logoUrl: "https://tg-external-entities-prod.tarabut.com/BASA-SAU.png",
    countryCode: "SAU",
    aisStatus: "AVAILABLE",
    pisStatus: "UNAVAILABLE",
    supportedAISAuthType: ["Bank"],
    supportedPISAuthType: ["Bank"],
  },
  {
    providerId: "SAIB-SAU",
    name: "The Saudi Investment Bank",
    displayName: "SAIB",
    arabicDisplayName: "البنك السعودي للاستثمار",
    logoUrl: "https://tg-external-entities-prod.tarabut.com/SAIB-SAU.png",
    countryCode: "SAU",
    aisStatus: "UNAVAILABLE",
    pisStatus: "UNAVAILABLE",
    supportedAISAuthType: ["Bank"],
    supportedPISAuthType: ["Bank"],
  },
  {
    providerId: "ANBB",
    name: "Arab National Bank",
    displayName: "ANB",
    arabicDisplayName: "البنك العربي الوطني",
    logoUrl: "https://tg-external-entities-prod.tarabut.com/ANBB.svg",
    countryCode: "SAU",
    aisStatus: "AVAILABLE",
    pisStatus: "UNAVAILABLE",
    supportedAISAuthType: ["Bank"],
    supportedPISAuthType: ["Bank"],
  },
  {
    providerId: "ALRA-SAU",
    name: "Al Rajhi Bank",
    displayName: "Al Rajhi Bank",
    arabicDisplayName: "مصرف الراجحي",
    logoUrl: "https://tg-external-entities-prod.tarabut.com/ALRA-SAU.png",
    countryCode: "SAU",
    aisStatus: "AVAILABLE",
    pisStatus: "UNAVAILABLE",
    supportedAISAuthType: ["Bank"],
    supportedPISAuthType: ["Bank"],
  },
  {
    providerId: "BAJA-SAU",
    name: "Bank AlJazira",
    displayName: "Bank AlJazira",
    arabicDisplayName: "بنك الجزيرة",
    logoUrl: "https://tg-external-entities-prod.tarabut.com/BAJA-SAU.svg",
    countryCode: "SAU",
    aisStatus: "AVAILABLE",
    pisStatus: "UNAVAILABLE",
    supportedAISAuthType: ["Bank"],
    supportedPISAuthType: ["Bank"],
  },
  {
    providerId: "MEEM-SAU",
    name: "Meem by Gulf International Bank",
    displayName: "Meem",
    arabicDisplayName: "بنك ميم",
    logoUrl: "https://tg-external-entities-prod.tarabut.com/MEEM-SAU.png",
    countryCode: "SAU",
    aisStatus: "AVAILABLE",
    pisStatus: "UNAVAILABLE",
    supportedAISAuthType: ["Bank"],
    supportedPISAuthType: ["Bank"],
  },
  {
    providerId: "INMA",
    name: "Alinma Bank",
    displayName: "Alinma Bank",
    arabicDisplayName: "مصرف الإنماء",
    logoUrl: "https://tg-external-entities-prod.tarabut.com/INMA.svg",
    countryCode: "SAU",
    aisStatus: "AVAILABLE",
    pisStatus: "UNAVAILABLE",
    supportedAISAuthType: ["Bank"],
    supportedPISAuthType: ["Bank"],
  },
];

const SelectBankModal = ({ visible, onClickBackdrop }) => {
  const { selectedBanks, handleSelectedBanks, product, providers } = useApp();
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];
  const providerList =
    product === "fleet-financing-beta" ? staticProviders : providers;
  const handleOnClickBank = (bank) => {
    handleSelectedBanks([...selectedBanks, bank]);
    onClickBackdrop();
  };

  const isBankSelected = (bank) => {
    return selectedBanks.some((b) => b.providerId === bank.providerId);
  };

  return (
    <div>
      <div
        className={`select-bank-modal-container ${visible ? "show" : "hide"}`}
        onClick={onClickBackdrop}
      >
        <div
          className="select-bank-modal-content"
          onClick={(event) => event.stopPropagation()}
        >
          <div className="modal-handle" />
          <img
            src={Close}
            onClick={onClickBackdrop}
            alt="close icon"
            className={"modal-close-icon"}
          />
          <h2 className="modal-title">
            {t(`${routeName}.select_your_bank_name_heading`)}
          </h2>
          <p className="modal-description">
            {t(`${routeName}.select_your_bank_name_description`)}
          </p>
          <div className="modal-bank-card-container">
            {providerList.map((item) => {
              const isSelected = isBankSelected(item);
              const bankLogo = getBankLogos(item.providerId);
              return (
                <div
                  className={`modal-bank-card ${isSelected && "selected"}`}
                  onClick={() => (!isSelected ? handleOnClickBank(item) : null)}
                >
                  <img
                    src={bankLogo}
                    alt={item.displayName}
                    className="bank-logo"
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectBankModal;
